export const MSG_PAGE_MEDIA_CONTENT_LOADED = 'page-media-content-loaded';
export const MSG_PAGE_MEDIA_DOWNLOADED = 'page-media-downloaded';

export const MSG_EXT_PING_SHOWTIME = 'ping-showtime';
export const MSG_EXT_LOAD_MEDIA_ASYNC = 'load-media-async';
export const MSG_EXT_DOWNLOAD_MEDIA_ASYNC = 'download-media-async';
